export default __webpack_public_path__ + "static/media/physio.e5da5ab3.png";